import { useOktaAuth } from '@okta/okta-react';
import { TdsLoadingSpinner } from '@trv-tds/react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router';
import { useEffect } from 'react';

export const SecureRoute = () => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, authState]);

  if (!authState || !authState?.isAuthenticated) {
    return <TdsLoadingSpinner centered label="Authenticating..." />;
  }

  return <Outlet />;
};
